module.exports = __webpack_public_path__ + "img/warning.eae50d96.svg";